import { AccountRepositorySearchParams } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import { UpdateAccountResponse } from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import {
  AccountOpenRequestType,
  AvailableSavingsProductType,
  CloseSavingsAccountRequest,
  CreateSavingsAccountRequest,
  InternalTransferRequest,
  NominatedAccountStatus,
  PispDepositResponse,
  PispSupportedInstitution,
  SavingsAccountInfoTypeResponse,
  SupportedInstitution,
  WithdrawFromSavingsAccountRequest,
} from '@app/finxone-web-frontend/app/lib/services/savings-account-service/savings-account.type';
import {
  AccountStatusType,
  MaturityDecisionRequest,
  NominatedAccountInfoDetailType,
  NominatedAccountStatusEnum,
  PaginatedResponse,
  PISPDepositStatusEnum,
  ResponseWithAlertCodesType,
  SavingsAccountInfoType,
  SavingsAccountTypeEnum,
} from '@finxone-platform/shared/sys-config-types';
import { Observable, map, of } from 'rxjs';

export class MockSavingsAccountService {
  public fetchNominatedAccountStatus(): Observable<NominatedAccountStatus> {
    return of({
      status: NominatedAccountStatusEnum.CONNECTED,
      accountId: '2a1cce0b-93f4-4dfd-acb2-c6cdd89338d5',
    });
  }

  public fetchSupportedAispInstitutions(): Observable<SupportedInstitution[]> {
    return of([
      {
        id: 'ABNAMRO_ABNAGB2LXXX',
        name: 'ABN AMRO Bank Commercial',
        bic: 'ABNAGB2LXXX',
        transaction_total_days: '540',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/abnamrobank.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'AIRWALLEX_AIPTAU32',
        name: 'Airwallex',
        bic: 'AIPTAU32',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/AIRWALLEX_AIPTAU32_1.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'ALLICA_CIIVGB2AXXX',
        name: 'Allica Bank',
        bic: 'CIIVGB2AXXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/allica.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'AIB_AIBKGB2LXXX',
        name: 'Allied Irish Banks',
        bic: 'AIBKGB2LXXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'AIB_FTBKGB2BXXX',
        name: 'Allied Irish Banks (NI)',
        bic: 'FTBKGB2BXXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_AMAZON_NEWDUK00X01',
        name: 'Amazon card (Newday)',
        bic: 'NEWDUK00X01',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_AMAZON_NEWDUK00X01.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'AMERICAN_EXPRESS_AESUGB21',
        name: 'American Express',
        bic: 'AESUGB21',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/AMERICAN_EXPRESS_AESUGB21.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_AQUA_NEWDUK00X02',
        name: 'Aqua card (Newday)',
        bic: 'NEWDUK00X02',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_AQUA_NEWDUK00X02.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'ARBUTHNOT_LATHAM_ARBUGB2LXXX',
        name: 'Arbuthnot Latham',
        bic: 'ARBUGB2LXXX',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/arbuthnotlatham.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_ARGOS_NEWDUK00X04',
        name: 'Argos card (Newday)',
        bic: 'NEWDUK00X04',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_ARGOS_NEWDUK00X04.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BANK_OF_IRELAND_B365_BOFIGB2B',
        name: 'Bank of Ireland 365 Online',
        bic: 'BOFIGB2B',
        transaction_total_days: '365',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofireland.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BANK_OF_IRELAND_BUSINESS_ONLINE_BOFIGB2B',
        name: 'Bank of Ireland Business On Line',
        bic: 'BOFIGB2B',
        transaction_total_days: '365',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/bankofirelandbusiness_uk',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BANK_OF_SCOTLAND_BUSINESS_BOFSGBS1',
        name: 'Bank of Scotland Business',
        bic: 'BOFSGBS1',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandbusiness.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BANK_OF_SCOTLAND_COMMERCIAL_BOFSGBS1',
        name: 'Bank of Scotland Commercial',
        bic: 'BOFSGBS1',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandbusiness.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BANK_OF_SCOTLAND_BOFSGBS1',
        name: 'Bank of Scotland Personal',
        bic: 'BOFSGBS1',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandpersonal.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BARCLAYCARD_COMMERCIAL_BUKBGB22',
        name: 'Barclaycard Commercial Payments',
        bic: 'BUKBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclaycard.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BARCLAYCARD_BUKBGB22',
        name: 'Barclaycard UK',
        bic: 'BUKBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclaycard.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BARCLAYS_BUSINESS_BUKBGB22',
        name: 'Barclays Business',
        bic: 'BUKBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BARCLAYS_CORPORATE_BUKBGB22',
        name: 'Barclays Corporate',
        bic: 'BUKBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BARCLAYS_BUKBGB22',
        name: 'Barclays Personal',
        bic: 'BUKBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayspersonal.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BARCLAYS_WEALTH_BUKBGB22',
        name: 'Barclays Wealth',
        bic: 'BUKBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'BBVAUK_BBVAGB2L',
        name: 'BBVA',
        bic: 'BBVAGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bbva.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_BIP_NEWDUK00X05',
        name: 'BIP card (Newday)',
        bic: 'NEWDUK00X05',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_BIP_NEWDUK00X05.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_BURTON_NEWDUK00X06',
        name: 'Burton card (Newday)',
        bic: 'NEWDUK00X06',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_BURTON_NEWDUK00X06.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'CAPITALONE_NFBKUSF1XXX',
        name: 'Capital One',
        bic: 'NFBKUSF1XXX',
        transaction_total_days: '180',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/capitalone.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'CAXTON_CAXTGB2L',
        name: 'Caxton',
        bic: 'CAXTGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/CAXTON_CAXTGB2L.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'COUTTS_COUTGB22XXX',
        name: 'Coutts&Co',
        bic: 'COUTGB22XXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/coutts.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'COUTTS_CS_COUTGB22XXX',
        name: 'Coutts&Co ClearSpend',
        bic: 'COUTGB22XXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/coutts.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'CUMBERLAND_CMBSGB2AXXX',
        name: 'Cumberland Building Society',
        bic: 'CMBSGB2AXXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/cumberland.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_DEBENHAMS_NEWDUK00X07',
        name: 'Debenhams card (Newday)',
        bic: 'NEWDUK00X07',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_DEBENHAMS_NEWDUK00X07.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_DOROTHYPERKINS_NEWDUK00X08',
        name: 'Dorothy Perkins card (Newday)',
        bic: 'NEWDUK00X08',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_DOROTHYPERKINS_NEWDUK00X08.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'FINOM_FNOMDEB2',
        name: 'Finom',
        bic: 'FNOMDEB2',
        transaction_total_days: '365',
        countries: [
          'LV',
          'ES',
          'LI',
          'SI',
          'SK',
          'FI',
          'DK',
          'IS',
          'LT',
          'CY',
          'BE',
          'EE',
          'RO',
          'IE',
          'AT',
          'SE',
          'IT',
          'CZ',
          'GB',
          'NO',
          'NL',
          'PL',
          'GR',
          'PT',
          'BG',
          'MT',
          'DE',
          'HU',
          'FR',
          'HR',
          'LU',
        ],
        logo: 'https://cdn-logos.gocardless.com/ais/FINOM_SOBKDEBB.png',
        max_access_valid_for_days: '180',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'FIRST_DIRECT_MIDLGB22',
        name: 'First Direct',
        bic: 'MIDLGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/firstdirect',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_FLUID_NEWDUK00X10',
        name: 'Fluid card (Newday)',
        bic: 'NEWDUK00X10',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_FLUID_NEWDUK00X10.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'GOLDMAN_SACHS_GSILGB2X',
        name: 'Goldman Sachs',
        bic: 'GSILGB2X',
        transaction_total_days: '730',
        countries: ['GB', 'LU'],
        logo: 'https://cdn-logos.gocardless.com/ais/GOLDMAN_SACHS_GSILGB2X.png',
        max_access_valid_for_days: '180',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HALIFAX_HLFXGB22',
        name: 'Halifax Personal',
        bic: 'HLFXGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/halifax.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HANDELSBANKEN_HANDGB22',
        name: 'Handelsbanken Private',
        bic: 'HANDGB22',
        transaction_total_days: '395',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/handelsbanken.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HARGREAVES_LANSDOWN_HLSVGB22',
        name: 'Hargreaves Lansdown Saving Limited',
        bic: 'HLSVGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hargreaveslansdown.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_HOUSEOFFRASER_NEWDUK00X11',
        name: 'House of Fraser card (Newday)',
        bic: 'NEWDUK00X11',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_HOUSEOFFRASER_NEWDUK00X11.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HSBC_BUSINESS_HBUKGB4B',
        name: 'HSBC Business',
        bic: 'HBUKGB4B',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HSBC_KINETIC_HBUKGB4B',
        name: 'HSBC Kinetic',
        bic: 'HBUKGB4B',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HSBC_HBUKGB4B',
        name: 'HSBC Personal',
        bic: 'HBUKGB4B',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'HSBC_NET_HBUKGB4B',
        name: 'HSBCnet',
        bic: 'HBUKGB4B',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'ING_WB_INGBNL2A',
        name: 'ING Wholesale Banking',
        bic: 'INGBNL2AXXX',
        transaction_total_days: '540',
        countries: [
          'DE',
          'SK',
          'ES',
          'NL',
          'RO',
          'AT',
          'BG',
          'BE',
          'CZ',
          'GB',
          'LU',
          'IE',
          'FR',
          'HU',
          'IT',
          'PT',
        ],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/DE/PNG/ing.png',
        max_access_valid_for_days: '180',
      },
      {
        id: 'LLOYDS_BUSINESS_LOYDGB2L',
        name: 'Lloyds Bank Business',
        bic: 'LOYDGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'LLOYDS_COMMERCIAL_LOYDGB2L',
        name: 'Lloyds Bank Commercial',
        bic: 'LOYDGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'LLOYDS_LOYDGB2L',
        name: 'Lloyds Bank Personal',
        bic: 'LOYDGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'LOMBARD_ODIER_GB_LOCYGB2L',
        name: 'Lombard Odier',
        bic: 'LOCYGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/LOMBARD_ODIER_LOCYLULL.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_MARBLES_NEWDUK00X13',
        name: 'Marbles card (Newday)',
        bic: 'NEWDUK00X13',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_MARBLES_NEWDUK00X13.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'MNS_MSFEGB21',
        name: 'Marks & Spencer',
        bic: 'MSFEGB21',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/marksandspencer.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'MBNA_MBNAGB22',
        name: 'MBNA Personal',
        bic: 'MBNAGB22',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/mbna.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'METTLE_NWBKGB2L',
        name: 'Mettle',
        bic: 'NWBKGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/mettle.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'MONESE_MNEEGB21',
        name: 'Monese',
        bic: 'MNEEGB21',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/FR/PNG/monese.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'MONZO_MONZGB2L',
        name: 'Monzo Bank Limited',
        bic: 'MONZGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/monzo.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NATIONWIDE_NAIAGB21',
        name: 'Nationwide Building Society',
        bic: 'NAIAGB21',
        transaction_total_days: '449',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/nationwide.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NATWEST_NWBKGB2L',
        name: 'Natwest',
        bic: 'NWBKGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NATWEST_CORP_NWBKGB2L',
        name: 'Natwest Bankline',
        bic: 'NWBKGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwestbankline.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NATWEST_CS_NWBKGB2L',
        name: 'Natwest ClearSpend',
        bic: 'NWBKGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NATWEST_INTERNATONAL_RBOSGIGI',
        name: 'Natwest International',
        bic: 'RBOSGIGI',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'PAYSAFE_NETEGB21',
        name: 'Neteller',
        bic: 'NETEGB21',
        transaction_total_days: '730',
        countries: [
          'LV',
          'ES',
          'LI',
          'SI',
          'SK',
          'FI',
          'DK',
          'IS',
          'LT',
          'CY',
          'BE',
          'EE',
          'RO',
          'IE',
          'AT',
          'SE',
          'IT',
          'CZ',
          'GB',
          'NO',
          'NL',
          'PL',
          'GR',
          'PT',
          'BG',
          'MT',
          'DE',
          'HU',
          'FR',
          'HR',
          'LU',
        ],
        logo: 'https://cdn-logos.gocardless.com/ais/PAYSAFE_NETEGB21.png',
        max_access_valid_for_days: '180',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_NEWPAY_NEWDUK00X15',
        name: 'Newpay card (Newday)',
        bic: 'NEWDUK00X15',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_NEWPAY_NEWDUK00X15.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_OPUS_NEWDUK00X16',
        name: 'Opus card (Newday)',
        bic: 'NEWDUK00X16',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_OPUS_NEWDUK00X16.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'PLEO_PLEODK00',
        name: 'Pleo',
        bic: 'PLEODK00',
        transaction_total_days: '90',
        countries: ['SE', 'GB', 'ES', 'DK', 'IE', 'DE'],
        logo: 'https://cdn-logos.gocardless.com/ais/PLEO_PLEODK00.png',
        max_access_valid_for_days: '180',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_PULSE_NEWDUK00X17',
        name: 'Pulse card (Newday)',
        bic: 'NEWDUK00X17',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_PULSE_NEWDUK00X17.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'REVOLUT_REVOGB21',
        name: 'Revolut',
        bic: 'REVOGB21',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/revolut.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'RBS_GB_RBSSGBKC',
        name: 'Royal Bank of Scotland',
        bic: 'RBSSGBKC',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbs.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'RBS_GB_CORP_RBSSGBKC',
        name: 'Royal Bank of Scotland Bankline',
        bic: 'RBSSGBKC',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbsbankline.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'RBS_GB_CS_RBSSGBKC',
        name: 'Royal Bank of Scotland ClearSpend',
        bic: 'RBSSGBKC',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbs.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'SAINSBURYS_SANBGB21',
        name: "Sainsbury's Bank",
        bic: 'SANBGB21',
        transaction_total_days: '180',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/sainsburysbank.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'SANTANDER_GB_ABBYGB2L',
        name: 'Santander',
        bic: 'ABBYGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'PAYSAFE_SKRLGB2L',
        name: 'Skrill',
        bic: 'SKRLGB2L',
        transaction_total_days: '730',
        countries: [
          'LV',
          'ES',
          'LI',
          'SI',
          'SK',
          'FI',
          'DK',
          'IS',
          'LT',
          'CY',
          'BE',
          'EE',
          'RO',
          'IE',
          'AT',
          'SE',
          'IT',
          'CZ',
          'GB',
          'NO',
          'NL',
          'PL',
          'GR',
          'PT',
          'BG',
          'MT',
          'DE',
          'HU',
          'FR',
          'HR',
          'LU',
        ],
        logo: 'https://cdn-logos.gocardless.com/ais/PAYSAFE_SKRLGB2L.png',
        max_access_valid_for_days: '180',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'STRIPE_STPUIE21',
        name: 'Stripe',
        bic: 'STPUIE21',
        transaction_total_days: '730',
        countries: [
          'LV',
          'ES',
          'LI',
          'SI',
          'SK',
          'FI',
          'DK',
          'IS',
          'LT',
          'CY',
          'BE',
          'EE',
          'RO',
          'IE',
          'AT',
          'SE',
          'IT',
          'CZ',
          'GB',
          'NO',
          'NL',
          'PL',
          'GR',
          'PT',
          'BG',
          'MT',
          'DE',
          'HU',
          'FR',
          'HR',
          'LU',
        ],
        logo: 'https://cdn-logos.gocardless.com/ais/STRIPE_STPUIE21.png',
        max_access_valid_for_days: '180',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'SMBC_SMBCGB2L',
        name: 'Sumitomo Mitsui Banking Corporation',
        bic: 'SMBCGB2L',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/SMBC_SMBCDEDD.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'THINKMONEY_THKMGB21',
        name: 'thinkmoney',
        bic: 'THKMGB21',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/THINKMONEY_THKMGB21.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'TIDE_TIDEGB00X01',
        name: 'Tide',
        bic: 'TIDEGB00X01',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tide.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'TRIODOS_TRIOGB22',
        name: 'Triodos Bank',
        bic: 'TRIOGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/triodosbank.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'TSB_GB_TSBSGB2A',
        name: 'TSB Bank',
        bic: 'TSBSGB2A',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tsbbank.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_TUI_NEWDUK00X20',
        name: 'TUI card (Newday)',
        bic: 'NEWDUK00X20',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_TUI_NEWDUK00X20.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'ULSTER_ULSBGB2B',
        name: 'Ulster Bank',
        bic: 'ULSBGB2B',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/ulsterbank.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'UNION_UBPGGB2X',
        name: 'Union Bancaire Privée London',
        bic: 'UBPGGB2X',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/UNION_DBSALULLFND.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'UNITY_TRUST_UYTBGB22',
        name: 'Unity Trust Bank',
        bic: 'UYTBGB22',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/UNITY_TRUST_UYTBGB22.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'VANQUIS_VQISGB21',
        name: 'Vanquis Bank',
        bic: 'VQISGB21',
        transaction_total_days: '180',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/vanquis.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'VIRGIN_NRNBGB22',
        name: 'Virgin Money - sort code starts with 05 or 82',
        bic: 'NRNBGB22',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/virginmoney.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'VIRGIN_STANDALONE_NRNBGB22',
        name: 'Virgin Money - sort code starts with 08',
        bic: 'NRNBGB22',
        transaction_total_days: '90',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/virginmoney.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'NEWDAY_WALLIS_NEWDUK00X21',
        name: 'Wallis card (Newday)',
        bic: 'NEWDUK00X21',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://cdn-logos.gocardless.com/ais/NEWDAY_WALLIS_NEWDUK00X21.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'WISE_TRWIGB22',
        name: 'Wise',
        bic: 'TRWIGB22XXX',
        transaction_total_days: '730',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/wise.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
      {
        id: 'CASHPLUS_NWBKGB2L',
        name: 'Zempler Bank',
        bic: 'APSFGB2L',
        transaction_total_days: '540',
        countries: ['GB'],
        logo: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/zemplerbank.png',
        max_access_valid_for_days: '90',
        max_access_valid_for_days_reconfirmation: '730',
      },
    ]);
  }

  public fetchSupportedPispInstitutions(country: string): Observable<PispSupportedInstitution[]> {
    return of([
      {
        id: 'NATWEST_NWBKGB2L',
        name: 'Natwest',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'MONZO_MONZGB2L',
        name: 'Monzo',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/monzo.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/monzo.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'SANTANDER_GB_ABBYGB2L',
        name: 'Santander Personal',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BARCLAYS_BUKBGB22',
        name: 'Barclays Personal',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayspersonal.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayspersonal.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'LLOYDS_LOYDGB2L',
        name: 'Lloyds Personal',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'HSBC_HBUKGB4B',
        name: 'HSBC Personal',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'STARLING_SRLGGB3L',
        name: 'Starling',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/starling.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/starling.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'REVOLUT_REVOGB21',
        name: 'Revolut',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/revolut.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/revolut.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'HALIFAX_HLFXGB22',
        name: 'Halifax Personal',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/halifax.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/halifax.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'NATIONWIDE_NAIAGB21',
        name: 'Nationwide',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/nationwide.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/nationwide.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'RBS_GB_RBSSGBKC',
        name: 'Royal Bank of Scotland',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbs.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbs.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'VIRGIN_NRNBGB22',
        name: 'Virgin Money - sort code starts with 05 or 82',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/virginmoney.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/virginmoney.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'TSB_GB_TSBSGB2A',
        name: 'TSB Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tsbbank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tsbbank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BANK_OF_SCOTLAND_BOFSGBS1',
        name: 'Bank of Scotland Personal',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandpersonal.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandpersonal.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'FIRST_DIRECT_MIDLGB22',
        name: 'First Direct',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/firstdirect',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/firstdirect',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'MONESE_MNEEGB21',
        name: 'Monese',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/FR/PNG/monese.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/FR/PNG/monese.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'METTLE_NWBKGB2L',
        name: 'Mettle',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/mettle.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/mettle.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'LLOYDS_COMMERCIAL_LOYDGB2L',
        name: 'Lloyds Commercial',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'LLOYDS_BUSINESS_LOYDGB2L',
        name: 'Lloyds Business',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/lloyds.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'NATWEST_CORP_NWBKGB2L',
        name: 'Natwest Bankline',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwestbankline.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwestbankline.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'NATWEST_INTERNATONAL_RBOSGIGI',
        name: 'Natwest International',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/natwest.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'RBS_GB_CORP_RBSSGBKC',
        name: 'Royal Bank of Scotland Bankline',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbsbankline.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/rbsbankline.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'SANTANDER_GB_BUSINESS_ABBYGB2L',
        name: 'Santander Business',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'SANTANDER_GB_CORP_ABBYGB2L',
        name: 'Santander Corporate',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/santander.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'TESCOBANK_TPFGGB2E',
        name: 'Tesco Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tescobank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tescobank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'COOPERATIVE_CPBKGB22',
        name: 'The Co-Operative Bank Business',
        logo_url: 'https://cdn-logos.gocardless.com/ais/COOPERATIVE_CPBKGB22.png',
        icon_url: 'https://cdn-logos.gocardless.com/ais/COOPERATIVE_CPBKGB22.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'COOPERATIVE_RETAIL_CPBKGB22',
        name: 'The Co-Operative Bank Retail',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/coop.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/coop.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'TIDE_TIDEGB00X01',
        name: 'Tide',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tide.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/tide.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'ULSTER_ULSBGB2B',
        name: 'Ulster Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/ulsterbank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/ulsterbank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'UNITY_TRUST_UYTBGB22',
        name: 'Unity Trust Bank',
        logo_url: 'https://cdn-logos.gocardless.com/ais/UNITY_TRUST_UYTBGB22.png',
        icon_url: 'https://cdn-logos.gocardless.com/ais/UNITY_TRUST_UYTBGB22.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'VIRGIN_STANDALONE_NRNBGB22',
        name: 'Virgin Money - sort code starts with 08',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/virginmoney.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/virginmoney.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'WISE_TRWIGB22',
        name: 'Wise',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/wise.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/wise.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: false,
        status: 'enabled',
      },
      {
        id: 'YBS_YORBGB2V',
        name: 'Yorkshire Building Society',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/yorkshirebank.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/yorkshirebank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CASHPLUS_NWBKGB2L',
        name: 'Zempler Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/zemplerbank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/zemplerbank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'ALLICA_CIIVGB2AXXX',
        name: 'Allica Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/allica.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/allica.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'AIB_AIBKGB2LXXX',
        name: 'Allied Irish Banks',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'AIB_FTBKGB2BXXX',
        name: 'Allied Irish Banks (NI)',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'AIB_CORP_AIBKGB2LXXX',
        name: 'Allied Irish Banks Corporate',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/IE/PNG/aib.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'ALPHA_FX_APAHGB2L',
        name: 'Alpha FX',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/alphafx.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/alphafx.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'ARBUTHNOT_LATHAM_ARBUGB2LXXX',
        name: 'Arbuthnot Latham',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/arbuthnotlatham.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/arbuthnotlatham.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BANK_OF_IRELAND_B365_BOFIGB2B',
        name: 'Bank of Ireland 365 Online',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofireland.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofireland.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BANK_OF_IRELAND_BUSINESS_ONLINE_BOFIGB2B',
        name: 'Bank of Ireland Business On Line',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/bankofirelandbusiness_uk',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/bankofirelandbusiness_uk',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BANK_OF_SCOTLAND_BUSINESS_BOFSGBS1',
        name: 'Bank of Scotland Business',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandbusiness.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandbusiness.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BANK_OF_SCOTLAND_COMMERCIAL_BOFSGBS1',
        name: 'Bank of Scotland Commercial',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandbusiness.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/bankofscotlandbusiness.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BARCLAYCARD_COMMERCIAL_BUKBGB22',
        name: 'Barclaycard Commercial Payments',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclaycard.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclaycard.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BARCLAYCARD_BUKBGB22',
        name: 'Barclaycard UK',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclaycard.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclaycard.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BARCLAYS_BUSINESS_BUKBGB22',
        name: 'Barclays Business',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BARCLAYS_CORPORATE_BUKBGB22',
        name: 'Barclays Corporate',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'BARCLAYS_WEALTH_BUKBGB22',
        name: 'Barclays Wealth',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/barclayscorporate.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'HOARES_HOABGB2L',
        name: 'C. Hoare & Co',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/choare.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/choare.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CAFBANK_CAFBGB21XXX',
        name: 'CAF Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/caf.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/caf.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CATER_ALLEN_CATEGB21',
        name: 'Cater Allen',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/caterallen.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/caterallen.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CAXTON_CAXTGB2L',
        name: 'Caxton',
        logo_url: 'https://cdn-logos.gocardless.com/ais/CAXTON_CAXTGB2L.png',
        icon_url: 'https://cdn-logos.gocardless.com/ais/CAXTON_CAXTGB2L.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CHASE_CHASGB2L',
        name: 'Chase Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/chasebank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/chasebank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CHE_CHELGB21',
        name: 'Chelsea Building Society',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/chelsea.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/chelsea.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CITI_CITIGB2L',
        name: 'Citi Private Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/citibank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/citibank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'COUTTS_COUTGB22XXX',
        name: 'Coutts',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/coutts.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/coutts.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CUMBERLAND_CMBSGB2AXXX',
        name: 'Cumberland Building Society',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/cumberland.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/cumberland.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'CYNERGY_BCYPGB2LXXX',
        name: 'Cynergy Bank',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/cynergybank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/cynergybank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'DANSKEBANK_BUSINESS_DABAGB2B',
        name: 'Danske Bank Business',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/danskebank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/danskebank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'DANSKEBANK_DABAGB2B',
        name: 'Danske Bank Private',
        logo_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/danskebank.png',
        icon_url: 'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/danskebank.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'HSBC_BUSINESS_HBUKGB4B',
        name: 'HSBC Business',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'HSBC_KINETIC_HBUKGB4B',
        name: 'HSBC Kinetic',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
      {
        id: 'HSBC_NET_HBUKGB4B',
        name: 'HSBCnet',
        logo_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        icon_url:
          'https://storage.googleapis.com/gc-prd-institution_icons-production/UK/PNG/hsbcpersonal.png',
        country_code: 'GB',
        autocompletes_collect_bank_account: true,
        status: 'enabled',
      },
    ]);
  }

  public getSavingAccounts(
    params: AccountRepositorySearchParams,
  ): Observable<PaginatedResponse<SavingsAccountInfoType>> {
    return of({
      page: params.page ?? 1,
      limit: params.size ?? 10,
      totalPages: 1,
      totalItems: 1,
      result: [
        {
          clientName: 'John Doe',
          organisationId: '2345678976545',
          accountId: '35748453',
          accountType: SavingsAccountTypeEnum.easyAccess,
          currency: 'GBP',
          country: 'GB',
          accountName: 'Easy Access Savings',
          isFundingEnabled: true,
          isRenewalEnabled: true,
          accountIdentifier: [
            {
              accountNumber: '35748453',
              sortCode: '123456',
              providerExtraInfo: {
                'faster-payments': {
                  country: 'GB',
                  currency: 'GBP',
                  accountNumber: '35748453',
                  routingCodes: {
                    'sort-code': '123456',
                  },
                },
              },
            },
          ],
          startDate: '2022-01-01',
          endDate: null,
          interestRate: 3.83,
          balance: '23347.14',
          availableBalance: '23347.14',
          status: AccountStatusType.active,
          interestAccrued: '454.20',
          deposits: '40016.00',
          interestAtMaturity: '5378.93',
          balanceAtMaturity: '45394.93',
          productCode: '101',
          productName: 'Easy Access savings',
          annualEquivalantInterestRate: 3.83,
          metadata: {
            thisbank: {
              accountType: 'SA',
              accountCode: 100,
              accountDescription: 'Easy Access Savings Account',
              accountPurpose: 'Main',
              accountName: 'Easy Access Savings Account',
              accountNumber: '35748453',
              sortCode: '041333',
              startDate: '2025-12-30',
              endDate: null,
              termMonths: null,
              balance: '0.00',
              availableBalance: '0.00',
              interestRate: 0,
              status: 'Closed',
              interestAccrued: '0.00',
              deposits: '0.00',
              interestAtMaturity: null,
              balanceAtMaturity: null,
              aer: 0,
              isFundingEnabled: false,
              isWithdrawalEnabled: false,
              isClosureEnabled: false,
              isRenewalEnabled: false,
              withdrawalCount: 1,
              maxNrOfWithdrawal: 3,
              lastFundingDate: '2026-01-14',
              minBalance: '1.00',
              maxDeposit: '500000.00',
              withdrawalResetDate: null,
            },
          },
        },
        {
          clientName: 'John Doe',
          organisationId: '2345678976545',
          accountId: '35745753',
          accountType: SavingsAccountTypeEnum.easyAccess,
          currency: 'GBP',
          country: 'GB',
          accountName: 'Easy Access Savings',
          isWithdrawalEnabled: true,
          isClosureEnabled: true,
          isRenewalEnabled: false,
          accountIdentifier: [
            {
              accountNumber: '35745753',
              sortCode: '1264596',
              providerExtraInfo: {
                'faster-payments': {
                  country: 'GB',
                  currency: 'GBP',
                  accountNumber: '35745753',
                  routingCodes: {
                    'sort-code': '1264596',
                  },
                },
              },
            },
          ],
          startDate: '2022-07-01',
          endDate: null,
          interestRate: 3.83,
          balance: '999.14',
          availableBalance: '999.14',
          status: AccountStatusType.active,
          interestAccrued: '454.20',
          deposits: '40016.00',
          interestAtMaturity: '5378.93',
          balanceAtMaturity: '45394.93',
          productCode: '102',
          productName: 'Fixed 2 year term savings',
          annualEquivalantInterestRate: 3.83,
          metadata: {
            thisbank: {
              accountType: 'SA',
              accountCode: 100,
              accountDescription: 'Easy Access Savings Account',
              accountPurpose: 'Main',
              accountName: 'Easy Access Savings Account',
              accountNumber: '35745753',
              sortCode: '041333',
              startDate: '2025-12-30',
              endDate: null,
              termMonths: null,
              balance: '0.00',
              availableBalance: '0.00',
              interestRate: 0,
              status: 'Closed',
              interestAccrued: '0.00',
              deposits: '0.00',
              interestAtMaturity: null,
              balanceAtMaturity: null,
              aer: 0,
              isFundingEnabled: false,
              isWithdrawalEnabled: true,
              isClosureEnabled: true,
              isRenewalEnabled: false,
              withdrawalCount: -2,
              maxNrOfWithdrawal: 5,
              lastFundingDate: '2026-01-14',
              minBalance: '1.00',
              maxDeposit: '500000.00',
              withdrawalResetDate: null,
            },
          },
        },
        {
          clientName: 'John Doe',
          organisationId: '2345678976545',
          accountId: '45748353',
          accountType: SavingsAccountTypeEnum.fixedTerm,
          currency: 'GBP',
          country: 'GB',
          accountName: 'Fixed Term 3yr Savings',
          isFundingEnabled: true,
          isWithdrawalEnabled: true,
          isRenewalEnabled: false,
          accountIdentifier: [
            {
              accountNumber: '45748353',
              sortCode: '123456',
              providerExtraInfo: {
                'faster-payments': {
                  country: 'GB',
                  currency: 'GBP',
                  accountNumber: '45748353',
                  routingCodes: {
                    'sort-code': '123456',
                  },
                },
              },
            },
          ],
          startDate: '2025-01-01',
          endDate: '2028-01-01',
          interestRate: 4.3,
          balance: '23347.14',
          availableBalance: '23347.14',
          status: AccountStatusType.active,
          interestAccrued: '454.20',
          deposits: '40016.00',
          interestAtMaturity: '5378.93',
          balanceAtMaturity: '45394.93',
          productCode: '101',
          productName: 'Easy Access savings',
          annualEquivalantInterestRate: 3.83,
          metadata: {
            thisbank: {
              accountType: 'SA',
              accountCode: 100,
              accountDescription: 'Easy Access Savings Account',
              accountPurpose: 'Main',
              accountName: 'Easy Access Savings Account',
              accountNumber: '45748353',
              sortCode: '041333',
              startDate: '2025-12-30',
              endDate: null,
              termMonths: null,
              balance: '0.00',
              availableBalance: '0.00',
              interestRate: 0,
              status: 'Closed',
              interestAccrued: '0.00',
              deposits: '0.00',
              interestAtMaturity: null,
              balanceAtMaturity: null,
              aer: 0,
              isFundingEnabled: true,
              isWithdrawalEnabled: true,
              isClosureEnabled: false,
              isRenewalEnabled: false,
              withdrawalCount: 2,
              maxNrOfWithdrawal: 3,
              lastFundingDate: '2026-01-14',
              minBalance: '1.00',
              maxDeposit: '500000.00',
              withdrawalResetDate: null,
            },
          },
        },
      ],
    });
  }

  public updateSavingAccount(
    accountId: string,
    update: { name?: string },
  ): Observable<UpdateAccountResponse> {
    return of({ data: { message: 'Account updated successfully' }, alertCodes: [] });
  }

  public fetchNominatedAccountDetails(accounts: string[]): Observable<any> {
    return of([
      {
        accountId: '2a1cce0b-93f4-4dfd-acb2-c6cdd89338d5',
        resourceId: '01F3NS4YV94RA29YCH8R0F6BMF',
        iban: 'GL7270470000070479',
        currency: 'EUR',
        ownerName: 'John Doe',
        name: 'Main Account',
        product: 'Checkings',
        cashAccountType: 'CACC',
        address: {},
      },
      {
        accountId: '4ce81103-a775-4ffb-b30c-0b1494a3f274',
        resourceId: '01F3NS5ASCNMVCTEJDT0G215YE',
        iban: 'GL1011260000011263',
        currency: 'EUR',
        ownerName: 'Jane Doe',
        name: 'Main Account',
        product: 'Checkings',
        cashAccountType: 'CACC',
        address: {},
      },
    ]);
  }

  public fetchNominatedAccountInformation(
    nominatedAccountId: string,
  ): Observable<NominatedAccountInfoDetailType> {
    return of({
      accountId: '01F3NS4YV94RA29YCH8R0F6BMF',
      accountName: 'Main Account',
      currency: 'GBP',
      accountType: 'nominated',
      country: 'GB',
      pispInstitutionId: 'HSBC_KINETIC_HBUKGB4B',
      accountIdentifier: [
        {
          providerExtraInfo: {
            'faster-payments': {
              bankAddress: null,
              country: 'GB',
              currency: 'EUR',
              bankName: null,
              accountNumber: '12345678',
              routingCodes: {
                'sort-code': '040004',
              },
            },
          },
          accountNumber: '12345678',
          sortCode: '040004',
        },
      ],
      status: AccountStatusType.active,
    });
  }

  public getAvailableProducts(): Observable<AvailableSavingsProductType[]> {
    return of([
      {
        productName: 'Easy Access savings',
        accountType: 'easy-access',
        productCode: '101',
        interestRate: 3.47,
        aer: 3.47,
        description: 'Easy Access - Savings',
      },
      {
        productName: '2yr Fixed Term savings',
        accountType: 'fixed-term',
        productCode: '201',
        interestRate: 3.47,
        termMonths: 48,
        expiry: '2027-01-01',
        aer: 3.47,
        description: '2yr Fixed Term - Savings',
      },
    ]);
  }

  public checkPispDepositStatus(
    pispDepositRequestId: string,
    accountId: string,
  ): Observable<PispDepositResponse> {
    return of({
      status: PISPDepositStatusEnum.PENDING,
    });
  }

  public getAccountRequests(): Observable<AccountOpenRequestType[]> {
    return of([
      {
        id: '54321',
        status: 'awaiting-approval',
        additionalDetails: {
          sumsubApplicantId: 'abcde-12345-fghij-67890',
          type: 'savings',
          currency: 'GBP',
          savings: {
            accountType: 'easy-access',
            productCode: '101',
            interestRate: 3.47,
            termMonths: 12,
          },
        },
        organisationId: '9876543210',
        clientId: '512132',
        applicationReference: '00003302',
      },
      {
        id: '54322',
        status: 'awaiting-approval',
        additionalDetails: {
          sumsubApplicantId: 'abcde-12345-fghij-12345',
          type: 'savings',
          currency: 'GBP',
          savings: {
            accountType: 'fixed-term',
            productCode: '201',
            interestRate: 4.47,
            termMonths: 24,
          },
        },
        organisationId: '9876543210',
        clientId: '512132',
        applicationReference: '00003303',
      },
    ]);
  }

  public createSavingsAccount(
    payload: CreateSavingsAccountRequest,
  ): Observable<ResponseWithAlertCodesType<SavingsAccountInfoTypeResponse>> {
    return of({
      data: {
        accountId: '54321',
        requestId: '12345',
        status: 'awaiting-approval',
        sumsubAccessToken: undefined,
      },
      alertCodes: [],
    });
  }

  // GET /savings/:id — served from the same seed getSavingAccounts hands out so
  // balances, currencies and account types stay consistent between the two.
  public getActiveSavingAccountDetails(accountId: string): Observable<SavingsAccountInfoType> {
    return this.getSavingAccounts({ page: 1, size: 10 }).pipe(
      map(
        (accounts) =>
          accounts.result.find((account) => account.accountId === accountId) ?? accounts.result[0],
      ),
    );
  }

  // POST /savings/:id/withdraw answers with a withdrawal record; the native
  // flow and the widget bridge both discard it and derive the outcome from the
  // account, so only a plausible acknowledgement is needed.
  public withdrawFromSavingsAccount(
    accountId: string,
    requestPayload: WithdrawFromSavingsAccountRequest,
  ): Observable<any> {
    return of({
      id: '0f0f4a25-6a2e-4a3f-90f5-9cf9b2a1cbb1',
      accountId,
      amount: requestPayload.amount,
      currency: 'GBP',
      description: requestPayload.description ?? '',
      status: 'pending',
      createdDate: '2026-01-14T10:15:00.000Z',
    });
  }

  // The three void endpoints below answer 200 with no body.
  public initiateInternalTransfer(
    fromAccountId: string,
    payload: InternalTransferRequest,
  ): Observable<void> {
    return of(undefined);
  }

  public submitMaturityDecision(payload: MaturityDecisionRequest, accountId: string): Observable<void> {
    return of(undefined);
  }

  public closeSavingsAccount(accountId: string, payload: CloseSavingsAccountRequest): Observable<void> {
    return of(undefined);
  }
}
